window.addEventListener("load", function () {
  const dotsElement = document.querySelector(".flickity-page-dots");
  const dotElements = document.querySelectorAll(".dot");
  const imageCount = dotElements.length;

  dotElements.forEach((dot, index) => {
    dot.style.opacity = 0;
  });

  let wrapperElement = document.createElement("div");
  wrapperElement.classList.add("Obsidian__Gallery__Pagination__Wrapper")

  let currentElement = document.createElement("div");
  currentElement.textContent = "01";
  currentElement.classList.add("Obsidian__Gallery__Pagination__Current")

  let lineElement = document.createElement("div");
  lineElement.classList.add("Obsidian__Gallery__Pagination__Line")

  let allElement = document.createElement("div");
  allElement.textContent = `${imageCount}`;
  allElement.classList.add("Obsidian__Gallery__Pagination__All")

  dotsElement.appendChild(wrapperElement);
  wrapperElement.appendChild(currentElement);
  wrapperElement.appendChild(lineElement);
  wrapperElement.appendChild(allElement);
});
